import React from 'react';
import championShip2023Imagen from './campeonato_autonomico_aire_libre_2023.jpg';

export const DownLoadPoster2023 = (): React.ReactElement => {

    return (
        <img        
            src={championShip2023Imagen}
            alt='Campeonato autonómico aire libre 2023'
        />
    )
}